export const listToMap = (list, key) => {
  const result = {};
  list.forEach(value => {
    result[value[key]] = value;
  });
  return result;
};